import get from 'lodash/get';
import { 
  GET_ALL_PIPE_DETAILS, 
  GET_ALL_PIPE_DETAILS_SUCCESS, 
  GET_ALL_PIPE_DETAILS_FAILURE,
  CLEAR_ALL_PIPE_DETAILS,
  GET_LIST_MANUFACTURING_CATEGORY,
  GET_LIST_MANUFACTURING_CATEGORY_SUCCESS,
  GET_LIST_MANUFACTURING_CATEGORY_FAILURE
} from "./types";

const initialState = {
  isPipeDetailsLoading: false,
  pipeDetails: {},
  isManufacturingCategoryLoading: false,
  manufacturingCategories: [],
};

const setupDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_PIPE_DETAILS: {
      return {
        ...state,
        isPipeDetailsLoading: true,
      };
    }
    case GET_ALL_PIPE_DETAILS_SUCCESS: {
      const responseData = get(action, 'responseData', {});
      return {
        ...state,
        pipeDetails: responseData,
        isPipeDetailsLoading: false
      };
    }
    case GET_ALL_PIPE_DETAILS_FAILURE: {
      return {
        ...state,
        isPipeDetailsLoading: false
      };
    }
    case CLEAR_ALL_PIPE_DETAILS: {
      return {
        ...state,
        pipeDetails: {},
        isPipeDetailsLoading: false
      };
    }
    case GET_LIST_MANUFACTURING_CATEGORY: {
      return {
        ...state,
        isManufacturingCategoryLoading: true,
      };
    }
    case GET_LIST_MANUFACTURING_CATEGORY_SUCCESS: {
      const responseData = get(action, 'responseData', []);
      return {
        ...state,
        manufacturingCategories: responseData,
        isManufacturingCategoryLoading: false
      };
    }
    case GET_LIST_MANUFACTURING_CATEGORY_FAILURE: {
      return {
        ...state,
        isManufacturingCategoryLoading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default setupDataReducer;

